import { useEffect } from 'react';
// Lenis'in zorunlu CSS'i: <html>/<body> height:100% olduğunda scroll kilitlenir;
// bu stil html.lenis/body'yi height:auto yaparak akışı düzeltir. Salt CSS
// olduğu için ayrı stil bundle'ına gider, Lenis'in JS'ini sürüklemez.
import 'lenis/dist/lenis.css';

// Oryzo.ai benzeri yumuşak/atalet'li scroll akışı. Lenis, tekerlek girdisini
// lerp ile yumuşatarak akışı belli bir yavaşlıkta ilerletir.
// enabled=false → Lenis hiç kurulmaz, sayfa yerel (native) scroll kullanır.
// (Form gibi uzun/işlevsel sayfalarda atalet "yavaş/inemiyorum" hissi verdiği
// için kapatılır.)
//
// PERFORMANS: Lenis (+ CSS'i) yalnızca ANA SAYFADA etkin. Statik import
// edilirse main.js'e girer ve her sayfada indirilir; oysa /iletisim, /etkinlik
// gibi sayfalarda hiç çalıştırılmaz. Bu yüzden efektin içinde dinamik import
// edilir — yalnızca gerçekten açıldığında ayrı bir chunk olarak inar.
export function useSmoothScroll(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const reduce = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;
    const coarse = window.matchMedia('(pointer: coarse)').matches;
    const saveData =
      (navigator as Navigator & { connection?: { saveData?: boolean } })
        .connection?.saveData ?? false;
    if (reduce || coarse || saveData) return;

    // Efekt, modül gelmeden sökülürse (hızlı route değişimi) kurulumu iptal et.
    let cancelled = false;
    let rafId = 0;
    let destroy: (() => void) | undefined;
    let stopped = false;

    (async () => {
      const { default: Lenis } = await import('lenis');
      if (cancelled) return;

      const lenis = new Lenis({
        duration: 1.2, // atalet süresi — büyüdükçe daha "ağır"/yavaş akar
        easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
        touchMultiplier: 1.5,
      });

      const raf = (time: number) => {
        if (stopped) return;
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
      destroy = () => lenis.destroy();

      const onVisibility = () => {
        stopped = document.hidden;
        if (stopped) {
          cancelAnimationFrame(rafId);
          rafId = 0;
        }
        if (!stopped && !rafId) rafId = requestAnimationFrame(raf);
      };
      document.addEventListener('visibilitychange', onVisibility);
      destroy = () => {
        document.removeEventListener('visibilitychange', onVisibility);
        lenis.destroy();
      };
    })();

    return () => {
      cancelled = true;
      stopped = true;
      cancelAnimationFrame(rafId);
      destroy?.();
    };
  }, [enabled]);
}
